export default function Category(props)
{
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentcolor">
    <path d="M12 2l-5.5 9h11z"/>
    <circle cx="17.5" cy="17.5" r="4.5"/>
    <path d="M3 13.5h8v8H3z"/>
  </svg>;
}
